module.exports = __webpack_public_path__ + "static/media/close-icon.50b129bb.svg";